import { TableColumn } from "components/table/Table";
import TableImage from "components/table/renderComponents/TableImage";
import TableTruncate from "components/table/renderComponents/TableTruncate";

export interface Data {
  _id: string;
  name: string;
  code: string;
  image: string;
  createdAt: string;
}

export const columns: TableColumn<Data>[] = [
  {
    key: "_id",
    label: "id",
    sortable: true,
    render: (item: Data) => <TableTruncate text={item._id} withCopy />,
  },
  {
    key: "image",
    label: "image",
    sortable: true,
    render: (item: Data) => <TableImage image={item.image} isCircle />,
  },
  { key: "name", label: "name", sortable: true },
  { key: "code", label: "code", sortable: true },
  { key: "createdAt", label: "createdAt", sortable: true },
  // ----------------------- sample options with render -----------------------
  // {
  //   key: "address.city",
  //   label: "City",
  //   render: (item: any) => item.address.city, // Custom render for nested data
  // },
  // {
  //   key: "tags",
  //   label: "Tags",
  //   render: (item: any) =>
  //     item.tags.map((tag: string) => (
  //       <span key={tag} className="tag">
  //         {tag}
  //       </span>
  //     )),
  // },
];
